import { useEffect } from "react";
import { setCatalogOverrides, useLanguage } from "@mmm/ui";
import { getTranslationOverrides } from "../api/queries.js";

/** Static catalogs remain the fallback when the reviewed overlay is unavailable. */
export function useTranslationOverrides(): void {
  const { language } = useLanguage();
  useEffect(() => {
    if (language === "en") return;
    let active = true;
    const refresh = () => {
      void getTranslationOverrides({ locale: language }).then((result) => {
        if (active) setCatalogOverrides(language, result.overrides);
      }).catch(() => { /* Keep the checked-in catalog. */ });
    };
    refresh();
    const timer = window.setInterval(refresh, 5 * 60_000);
    window.addEventListener("focus", refresh);
    return () => { active = false; window.clearInterval(timer); window.removeEventListener("focus", refresh); };
  }, [language]);
}
